var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.videoClicked}},[_c('video',{ref:"videoPlayer",staticClass:"video-js video-iframe"})])
}
var staticRenderFns = []

export { render, staticRenderFns }